import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { TextField } from '@material-ui/core';
import { IntlShape, injectIntl } from 'react-intl';
import { StyledDiv } from 'containers/ExpertExpertise/Dialogs/styles';
import DialogMission from 'containers/ExpertExpertise/Dialogs/index';
import { translate } from 'containers/services/translate';
import messages from 'containers/ExpertExpertise/messages';
import { pushTo } from 'containers/services/routes-helper';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { PAGES } from 'routes';

export interface RejectMissionDialogProps {
  intl: IntlShape;
  open: boolean;
  onClose: Function;
  validateDialog: Function;
  assignementId: any;
  claimId: number;
  missionId: any;
}

const RejectMissionDialog: React.FC<RejectMissionDialogProps> = (
  props,
): JSX.Element => {
  const { onClose, open } = props;
  const [reason, setReason] = useState('');

  const handleChangeReason = (event: any) => {
    setReason(event.target.value);
  };
  const successCallBack = () => {
    toast.success(translate(messages.successToastRejectMission, props));
    props.onClose();
    pushTo(PAGES.EXPERT_ASSIGNED_MISSIONS)();
  };

  const handleValidate = () => {
    props.validateDialog(
      {
        id: props.assignementId,
        reason: reason,
        claimId: props.claimId,
        missionId: props.missionId,
        isTrackingActive: featureService.hasFeature(
          FEATURES.TRACKING_ACTIONS_USER,
        ),
      },
      successCallBack,
    );
  };
  return (
    <DialogMission
      open={open}
      onClose={onClose}
      validateDialog={handleValidate}
      title={translate({ ...messages.doesNotConcernMe }, props)}
      content={
        <StyledDiv>
          <TextField
            onChange={handleChangeReason}
            name={'reason'}
            value={reason}
            label={translate({ ...messages.reason }, props)}
            className="input"
            multiline
            fullWidth
          />
        </StyledDiv>
      }
      disabled={!reason}
    />
  );
};

RejectMissionDialog.defaultProps = {
  open: false,
};

export default injectIntl(RejectMissionDialog);
